import "./App.css";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import { UserProvider } from "./context/user";
import { LeaguesProvider } from "./context/leagues";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Routes, Route, useLocation } from "react-router-dom";
import PrivateRoute from "./components/privateRoute";
import AdminRoute from "./components/adminRoute";
import AdminDashboard from "./pages/AdminDashboard";
import Auth from "./pages/Auth";
import VerifyEmail from "./pages/VerifyEmail";
import ResetPassword from "./pages/ResetPassword";
import Privacy from "./pages/Privacy";
import ContactUs from "./pages/ContactUs";
import { ActionsProvider } from "./context/actions";
import ReactGA from "react-ga4";
import { useEffect } from "react";
import Unsubscribe from "./pages/Unsubscribe";
import TermsOfService from "./pages/TermsOfService";
import Feedback from './pages/Feedback';
import JoinLeague from "./pages/JoinLeague";


ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);

const theme = createTheme({
  palette: {
    primary: {
      main: "#090808",
    },
    secondary: {
      main: "#f5f5f0",
    },
    tertiary: {
      main: "#F4B942",
      contrastText: "#090808",
    },
    quarternary: {
      main: "#3f9b0b"
    }
  },
  components: {
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        color: "#dce8dd",
        "& .MuiOutlinedInput-input": {
          color: "#dce8dd",
        },
      },
      notchedOutline: {
        borderColor: "rgba(220, 232, 221, 0.4)",
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        color: "#dce8dd", // label text color
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        fontFamily: '"apotek-wide", sans-serif',
        fontWeight: 700,
        letterSpacing: "0.06em",
      },
    },
    variants: [
      {
        props: { variant: "contained", color: "tertiary" },
        style: {
          border: "1px solid transparent",
          "&:hover": {
            backgroundColor: "#090808",
            color: "#F4B942",
            border: "1px solid #F4B942",
          },
        },
      },
    ],
  },
},
});

function App() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <UserProvider>
          <LeaguesProvider>
            <ActionsProvider>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/verifyEmail" element={<VerifyEmail />} />
                <Route path="/resetPassword" element={<ResetPassword />} />
                <Route path="/contactus" element={<ContactUs />} />
                <Route path="/unsubscribe" element={<Unsubscribe />} />
                <Route path="/privacyPolicy" element={<Privacy />} />
                <Route path="/termsOfService" element={<TermsOfService />} />
                <Route path="/feedback" element={<Feedback />} />
                <Route path="/feedback/quick" element={<Feedback />} />
                <Route path="/feedback/thank-you" element={<Feedback />} />
                <Route path="/feedback/already-submitted" element={<Feedback />} />
                <Route path="/feedback/invalid" element={<Feedback />} />
                <Route path="/join/:token" element={<JoinLeague />} />
                <Route element={<PrivateRoute />}>
                  <Route path="/dashboard" element={<Dashboard />} />
                </Route>
                {/* TEMP QA ROUTE — remove before done */}
                <Route path="/__qa_dashboard" element={<Dashboard />} />
                <Route element={<AdminRoute />}>
                  <Route path="/admin" element={<AdminDashboard />} />
                </Route>
              </Routes>
            </ActionsProvider>
          </LeaguesProvider>
        </UserProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
